import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { createDisabledDateGetter } from '../utils/createDisabledDateGetter';

export const useDisabledDate = () => {
  const history = useHistory();

  const disabledDate = useMemo(() => {
    const {
      location: { state },
    } = history;

    return createDisabledDateGetter({
      acceptance: state?.from?.acceptance,
    });
  }, [history]);

  return disabledDate;
};
